// Общие стили модальных окон в стиле панели миссий
export const MODAL_CARD_CLASS = "modal-card-dark text-gray-400";
export const MODAL_HEADER_CLASS = "text-gray-100";
export const MODAL_SUBHEADER_CLASS = "text-gray-400";
export const MODAL_PRIMARY_BUTTON_CLASS = "bg-yellow-400 hover:bg-yellow-500 text-gray-800 border-yellow-400";
export const MODAL_SECONDARY_BUTTON_CLASS = "bg-gray-700 hover:bg-gray-600 text-gray-100 border-gray-600";
export const MODAL_INNER_CARD_CLASS = "bg-gray-700 border border-gray-800 text-gray-400";
export const MODAL_INNER_TEXT_CLASS = "text-gray-400";
